import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { FaArrowRight } from 'react-icons/fa'

import classes from './Schedule.module.css'

const defaultStyle = {
    margin: 0,
    padding: 0,
}

const Container = styled.div`
    display: flex;
    align-items: center;
    margin: ${props => props.styles.margin};
    padding: ${props => props.styles.padding};
`

const Label = styled.div`
    font-size: 0.8rem;
    margin: 0 0.2rem;
`

const Schedule = props => {
    const {
        dates,
        styles
    } = props;
    const updatedStyle = Object.assign({}, defaultStyle, styles)

    if(dates.start || dates.end){
        if(dates.start && dates.end){
            return (
                <Container styles={updatedStyle}>
                    {/* <div className={classes.Label}>{dates.start}</div>
                    <FaArrowRight className={classes.Icon}/>
                    <div className={classes.Label}>{dates.end}</div> */}
                    <Label>{`${dates.start} - ${dates.end}`}</Label>
                </Container> 
            )
        } else {
            return (
                <Label>{dates.start || dates.end}</Label>
            )
        }
    } 
}

export default Schedule

Schedule.propTypes = {
    dates: PropTypes.object.isRequired
}